import React, { useState } from 'react'
import { Accordion, Button, Col, Form, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import i18next from 'i18next'

interface PropsItem {
  items: any[],
  onAddItemSelected(itemIds: number[]): any
}

export const ModalAddItem: React.FC<PropsItem> = (props) => {

    const [showModalItem, setShowModalItem] = useState(false);
    const [itemChecked, setItemChecked] = useState<any[]>([])
    const {t} = useTranslation()

    const closeModalItem = () => setShowModalItem(false);

    const onSIPItemSelected = (index: any) => {
        const isChecked = document.getElementById(`checkbox${index}`) as HTMLInputElement
        if (isChecked.checked) {
            setItemChecked([... itemChecked, parseInt(isChecked.value)])
        } else {
            setItemChecked(itemChecked.filter((item: any) => item != parseInt(isChecked.value)))
        }
    }

    const addItem = (is_select_all?: boolean) => {

        is_select_all ? 
            props.onAddItemSelected(props.items.map((item: any) => item.id)) : 
            props.onAddItemSelected(itemChecked)

        closeModalItem()
        setItemChecked([])
    }

  return (
    <div>
        {props.items.length > 0 && (
            <>
                <button onClick={() => setShowModalItem(true)} className='btn btn-primary me-2'>
                    + {t('kontrak-tambah')} {t('Item')}
                </button>
                <Modal
                show={showModalItem}
                onHide={closeModalItem}
                centered
                size='xl'
                backdrop='static'
                keyboard={false}
                >
                <Modal.Header closeButton>
                    <Modal.Title>{t('pilih')} Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.items.map((item: any, index: any) => {
                    return (
                        <>
                        <Accordion>
                            <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                                {item?.id} / {item?.produsen?.name} / {item?.product_name} /{' '}
                                {item?.incoterm1?.code}
                                {item?.incoterm2 != null
                                ? '-' + item.incoterm2.code
                                : item.incoterm2_id != null && item.incoterm2_id != '0'
                                ? '-' + item.incoterm2_id
                                : ''}{' '}
                                / {item?.fixed_quantum} Ton
                            </Accordion.Header>
                            <Accordion.Body style={{backgroundColor: '#fff'}}>
                                {item.sector_id == 1 && (
                                <Row>
                                    <Col md='6'>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('pilih')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <input
                                            className='form-check-input'
                                            type='checkbox'
                                            id={'checkbox' + item.id}
                                            value={item.id}
                                            onClick={() => onSIPItemSelected(item.id)}
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>Sales Org</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            item.produsen?.name || item.sales_org_code_desc
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item.incoterm1?.code || item.incoterm1_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            type='text'
                                            value={
                                            item.province?.region_name || item.province_desc
                                            }
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item.product_type_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            type='text'
                                            value={
                                            item.plant == null
                                                ? ''
                                                : item.plant + ' - ' + item.plant_desc
                                            }
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>
                                            {item.product_type_desc == 'KANTONG/SACK'
                                            ? t('sack')
                                            : t(
                                                'CREATE_CONTRACT.ADD_ITEM_MODAL.QUANTUM_SIP_LABEL'
                                                )}
                                        </p>
                                        </Col>
                                        <Col md={7}>
                                        {item.product_type_desc == 'KANTONG/SACK' ? (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? parseFloat(item.fixed_quantum).toLocaleString(
                                                    'en',
                                                    {
                                                        maximumFractionDigits: 4,
                                                    }
                                                    ) + ' EA'
                                                : parseFloat(item.fixed_quantum).toLocaleString(
                                                    'id',
                                                    {
                                                        maximumFractionDigits: 4,
                                                    }
                                                    ) + ' EA'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        ) : (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? parseFloat(item.fixed_quantum).toLocaleString(
                                                    'en',
                                                    {
                                                        maximumFractionDigits: 4,
                                                    }
                                                    ) + ' Ton'
                                                : parseFloat(item.fixed_quantum).toLocaleString(
                                                    'id',
                                                    {
                                                        maximumFractionDigits: 4,
                                                    }
                                                    ) + ' Ton'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        )}
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>
                                            {item.product_type_desc == 'KANTONG/SACK'
                                            ? t('sack')
                                            : t(
                                                'CREATE_CONTRACT.ADD_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL'
                                                )}
                                        </p>
                                        </Col>
                                        <Col md={7}>
                                        {item.product_type_desc == 'KANTONG/SACK' ? (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? parseFloat(
                                                    (item.quantum_contract || 0)
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                                : parseFloat(
                                                    (item.quantum_contract || 0)
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        ) : (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? parseFloat(
                                                    (item.quantum_contract || 0)
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' Ton'
                                                : parseFloat(
                                                    (item.quantum_contract || 0)
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' Ton'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        )}
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            size='sm'
                                            type='text'
                                            id='shipping'
                                            value={
                                            item?.shipping_tolerance != '0'
                                                ? item?.shipping_tolerance + ' %'
                                                : ''
                                            }
                                            disabled
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            item?.payment_type_1_desc || item?.payment_type_1
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={t(item?.payment_note || item?.payment_notes)}
                                            as='textarea'
                                            disabled
                                            size='sm'
                                            style={{height: '40px'}}
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            item.end_user_detail?.name
                                                ? item.end_user_detail?.name
                                                : item.end_user
                                            }
                                            as='textarea'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    </Col>
                                    <Col md='6'>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>ID</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item?.id}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={t(item.sector?.name || 'Domestik Korperasi')}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                        </Col>
                                        <Col md={7}>
                                        {item?.incoterm2 == null ? (
                                            <Form.Control
                                            value={
                                                item?.incoterm2_id == null ||
                                                item?.incoterm2_id == '0'
                                                ? ''
                                                : item?.incoterm2_id
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        ) : (
                                            <Form.Control
                                            value={item?.incoterm2?.code}
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        )}
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            type='text'
                                            value={item?.city?.city_name || item?.city_desc}
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            item?.material_number?.slice(-7) +
                                            '-' +
                                            item?.product_name
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            as='textarea'
                                            style={{height: '40px'}}
                                            value={item.product_spec}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-2'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>
                                            {t('sub-order-hargaD')}/
                                            {item.product_type_desc == 'KANTONG/SACK'
                                            ? item.unit
                                            : 'Ton'}
                                        </p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            'Rp ' + (i18next.language === 'en'
                                                ? parseInt(item?.fixed_price).toLocaleString(
                                                    'en',
                                                    {maximumFractionDigits: 4}
                                                )
                                                : parseInt(item?.fixed_price).toLocaleString(
                                                    'id',
                                                    {maximumFractionDigits: 4}
                                                )
                                            )}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>
                                            {item.product_type_desc == 'KANTONG/SACK'
                                            ? t('sack')
                                            : t('sisaquantum')}
                                        </p>
                                        </Col>
                                        <Col md={7}>
                                        {item.product_type_desc == 'KANTONG/SACK' ? (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? (
                                                    parseFloat(item.fixed_quantum) -
                                                    parseFloat((item.quantum_contract || 0))
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                                : (
                                                    parseFloat(item.fixed_quantum) -
                                                    parseFloat((item.quantum_contract || 0))
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        ) : (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? (
                                                    parseFloat(item.fixed_quantum) -
                                                    parseFloat((item.quantum_contract || 0))
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' Ton'
                                                : (
                                                    parseFloat(item.fixed_quantum) -
                                                    parseFloat((item.quantum_contract || 0))
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' Ton'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        )}
                                        </Col>
                                    </Row>
                                    <Row className='mb-5'>
                                        <Col md={5}>
                                        <p className='fs-6 mt-4'>{t('termasuk-ppn')}</p>
                                        </Col>
                                        <Col sm={7} className='d-flex justify-content-start'>
                                        <Form.Check
                                            reverse
                                            name='ppn'
                                            className='mt-4 mb-2'
                                            type='checkbox'
                                            id='ckbox-ppn'
                                            checked={item?.include_ppn}
                                            disabled
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item?.payment_type_2_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('segment')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            type='text'
                                            value={t(item.segment_name)}
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item?.notes}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    </Col>
                                </Row>
                                )}

                                {item.sector_id == 3 && (
                                <Row>
                                    <Col md='6'>
                                    <Row className='mb-6'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('pilih')}</p>
                                        </Col>
                                        <Col md={7} className='d-flex align-items-center'>
                                        <input
                                            className='form-check-input'
                                            type='checkbox'
                                            id={'checkbox' + item.id}
                                            value={item.id}
                                            onClick={() => onSIPItemSelected(item.id)}
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>Sales Org</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            item.produsen?.name || item.sales_org_code_desc
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item.incoterm1?.code || item.incoterm1_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            type='text'
                                            value={
                                            item.province?.region_name || item.province_desc
                                            }
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item.product_type_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            type='text'
                                            value={item.plant_desc}
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>
                                            {item.product_type_desc == 'KANTONG/SACK'
                                            ? t('sack')
                                            : t(
                                                'CREATE_CONTRACT.ADD_ITEM_MODAL.QUANTUM_SIP_LABEL'
                                                )}
                                        </p>
                                        </Col>
                                        <Col md={7}>
                                        {item.product_type_desc == 'KANTONG/SACK' ? (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? parseFloat(
                                                        item.fixed_quantum
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                                : parseFloat(
                                                        item.fixed_quantum
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        ) : (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? parseFloat(
                                                        item.fixed_quantum
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' MT'
                                                : parseFloat(
                                                        item.fixed_quantum
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' MT'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        )}
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>
                                            {item.product_type_desc == 'KANTONG/SACK'
                                            ? t('sack')
                                            : t(
                                                'CREATE_CONTRACT.ADD_ITEM_MODAL.SUBMISSION_QUANTUM_LABEL'
                                                )}
                                        </p>
                                        </Col>
                                        <Col md={7}>
                                        {item.product_type_desc == 'KANTONG/SACK' ? (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? parseFloat(
                                                    (item.quantum_contract || 0)
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                                : parseFloat(
                                                    (item.quantum_contract || 0)
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        ) : (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? parseFloat(
                                                    (item.quantum_contract || 0)
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' MT'
                                                : parseFloat(
                                                    (item.quantum_contract || 0)
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' MT'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        )}
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('Shipping Tolerance')}</p>
                                        </Col>
                                        <Col sm={7}>
                                        <Form.Control
                                            size='sm'
                                            type='text'
                                            id='shipping'
                                            value={
                                            item?.shipping_tolerance != '0'
                                                ? item?.shipping_tolerance + ' %'
                                                : ''
                                            }
                                            disabled
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            item?.payment_type_1_desc || item?.payment_type_1
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('keterangan')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={t(item?.payment_note || item?.payment_notes)}
                                            as='textarea'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    </Col>
                                    <Col md='6'>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>ID</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item?.id}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={t(item.sector?.name || 'Ekspor')}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                                        </Col>
                                        <Col md={7}>
                                        {item?.incoterm2 == null ? (
                                            <Form.Control
                                            value={
                                                item?.incoterm2_id == null ||
                                                item?.incoterm2_id == '0'
                                                ? ''
                                                : item?.incoterm2_id
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        ) : (
                                            <Form.Control
                                            value={item?.incoterm2?.code}
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        )}
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            type='text'
                                            value={item?.city?.city_name || item?.city_desc}
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            item?.material_number?.slice(-7) +
                                                '-' +
                                            item?.product_name
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-spek')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            as='textarea'
                                            style={{height: '40px'}}
                                            value={item.product_spec}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>
                                            {t('sub-order-hargaD')}/
                                            {item.product_type_desc == 'KANTONG/SACK'
                                            ? item.unit
                                            : 'MT'}
                                        </p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            'USD ' + (i18next.language === 'en'
                                                ? parseFloat(
                                                    item?.fixed_price
                                                ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                })
                                                : parseFloat(
                                                    item?.fixed_price
                                                ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                })
                                            )}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>
                                            {item.product_type_desc == 'KANTONG/SACK'
                                            ? t('sack')
                                            : t('sisaquantum')}
                                        </p>
                                        </Col>
                                        <Col md={7}>
                                        {item.product_type_desc == 'KANTONG/SACK' ? (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? (
                                                    parseFloat(item.fixed_quantum) -
                                                    parseFloat((item.quantum_contract || 0))
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                                : (
                                                    parseFloat(item.fixed_quantum) -
                                                    parseFloat((item.quantum_contract || 0))
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' EA'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        ) : (
                                            <Form.Control
                                            value={
                                                i18next.language === 'en'
                                                ? (
                                                    parseFloat(item.fixed_quantum) -
                                                    parseFloat((item.quantum_contract || 0))
                                                    ).toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' Ton'
                                                : (
                                                    parseFloat(item.fixed_quantum) -
                                                    parseFloat((item.quantum_contract || 0))
                                                    ).toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                    }) + ' Ton'
                                            }
                                            type='text'
                                            disabled
                                            size='sm'
                                            />
                                        )}
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item?.notes}
                                            as='textarea'
                                            style={{height: '40px'}}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={item?.payment_type_2_desc}
                                            type='text'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    <Row className='mb-4'>
                                        <Col md={5}>
                                        <p className='mt-3 fs-6'>{t('sub-order-endUser')}</p>
                                        </Col>
                                        <Col md={7}>
                                        <Form.Control
                                            value={
                                            item.end_user_detail?.name
                                                ? item.end_user_detail?.name
                                                : item.end_user
                                            }
                                            as='textarea'
                                            disabled
                                            size='sm'
                                        />
                                        </Col>
                                    </Row>
                                    </Col>
                                </Row>
                                )}
                            </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        </>
                    )
                    })}
                    <div className='d-flex justify-content-end mt-5'>
                    <Button
                        className='justify-content-end me-1'
                        onClick={() => addItem(true)}
                        hidden={props.items.length < 2 ? true : false}
                    >
                        {t('selectall')}
                    </Button>
                    <Button
                        className='justify-content-end'
                        hidden={props.items.length < 1 ? true : false}
                        onClick={() => addItem()}
                    >
                        {t('Save')}
                    </Button>
                    </div>
                </Modal.Body>
                </Modal>
            </>
        )}
    </div>
  )
}
